module.exports = __webpack_public_path__ + "img/mo.2fd4d307.svg";